<!-- This component is used in both the TodayViewSession and TicketPickerSession components to display
info about a session. -->
<template>
    <div data-component="SessionInfo"
         class="session-info">
        <div class="session-info__text">
            <!-- Show the session start and end times with the date -->
            <p v-if="showDate"
               class="session-info__time">
                <i class="far fa-clock fa-fw" /> {{ dateFilter(session.startTime, true) }}
                <template v-if="session.endTime !== null">
                    <span class="far fa-arrow-right"></span>
                    {{ dateFilter(session.endTime, true) }}
                </template>
            </p>
            <!-- Show the session start and end times with only the time -->
            <p v-else
               class="session-info__time">
                <i class="far fa-clock fa-fw" /> {{ timeFilter(session.startTime) }}
                <template v-if="session.endTime !== null">
                    <span class="far fa-arrow-right"></span>
                    {{ timeFilter(session.endTime) }}
                </template>
            </p>

            <p v-if="session.name && (!event || session.name !== event.name)">
                <i class="far fa-info-circle fa-fw" />
                {{ session.name }}
            </p>

            <p v-if="event && showEventName">
                <i class="far fa-calendar-days fa-fw" />
                {{ event.name }}
            </p>

            <p v-if="isInactive">
                <span class="label label-warning">
                    {{ l('TODAY_VIEW.INACTIVE') }}
                </span>
            </p>
        </div>

        <SessionSpaceCounts v-if="availability"
                            class="session-info__spaces"
                            :availability="availability"
                            :spaces-required="spacesRequired" />
    </div>
</template>

<script>
import SessionSpaceCounts from '@/vue/components/Sessions/SessionSpaceCounts';

export default {
    name: 'SessionInfo',

    components: {
        SessionSpaceCounts,
    },

    props: {
        showDate: {
            type: Boolean,
            default: true,
        },

        showEventName: {
            type: Boolean,
            default: true,
        },

        /**
         * @type {Session}
         */
        session: {
            type: Object,
            required: true,
        },

        /**
         * @type {SessionEvent}
         */
        event: {
            type: Object,
            required: true,
        },

        /**
         * @type {SessionAvailability}
         */
        availability: {
            type: Object,
            default: null,
        },

        spacesRequired: {
            type: Number,
            default: null,
        },
    },

    computed: {
        isInactive() {
            return this.session.status === 'Inactive' // Session is Inactive.
                || (this.event && this.event.status === 'Inactive'); // Event is Inactive.
        },
    },
};
</script>

<style lang="less">
@import (reference) "../../../../less/variables";

.session-info {
    p {
        margin: 0;
    }
}

@media (max-width: @mobile-max) {
    .session-info {
        &__text {
            p {
                font-size: 13px;

                &:not(:last-child) {
                    margin-bottom: 3px;
                }
            }
        }

        &__time {
            font-weight: bold;
        }

        &__spaces {
            display: block;
            margin-top: 5px;
        }
    }
}

@media (min-width: @non-mobile-min) {
    .session-info {
        // Make the date/name and the space counts be on the same line on desktop,
        // instead of the space counts underneath on mobile.
        display: flex;
        align-items: center;

        &__text {
            flex-grow: 1;
            flex-shrink: 1;
        }

        &__spaces {
            flex-shrink: 0;
        }

        &__text {
            p {
                &:not(.session-info__time) {
                    font-size: 13px;
                }
            }
        }
    }
}
</style>
